// Login redirects to production, https://admin.boxcast.com/

export const API_ROOT = 'https://rest.boxcast.com';
export const INTEGRATIONS_ROOT = 'https://integration.boxcast.com';
export const KIBANA_URL = 'https://kibana.boxcast.com';
export const LOGIN_URL = 'https://login.boxcast.com';
export const AUTH_URL = 'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=N5YrtbykHOw-ry2FVocJ&redirect_uri=https%3A%2F%2Fadmin.boxcast.com%2F&scope=admin';
export const TOKEN_URL = 'https://rest.boxcast.com/oauth2/token';
export const LOGOUT_URL = 'https://rest.boxcast.com/oauth2/auth/sessions/login/revoke';
export const RPC_FIRMWARE_REVISION = 632;
export const EDID_FIRMWARE_REVISION = 4008;
export const ACCOUNT_ID_FOR_EXTENDED_TESTS = 'MANUFFIL';
export const PLAYER_ENV = 'prod';
export const ENV = 'prod';
export const GRAFANA_API_KEY = 'eyJrIjoiZXU5cDhwSHlLY2U5YkEyc0tIZzBUQlc5U3h6TGJmamEiLCJuIjoiYWRtaW4iLCJpZCI6MX0=';
export const GRAFANA_API_URL = 'https://grafana.boxcast.com/api/datasources/proxy';
export const GRAFANA_DEFAULT_DATASOURCE = '1';
export const GRAFANA_ORIGIN_DATASOURCE = '6';
export const GRAFANA_UPTIME_URL = 'https://grafana.boxcast.com/dashboard/db/boxcaster-uptime';
export const GRAFANA_DASHBOARD_URL = 'https://grafana.boxcast.com/dashboard/db';
export const DASHBOARD_URL = 'https://dashboard.boxcast.com';
export const NEW_ADMIN_URL = 'https://admin3.boxcast.com';
export const HUBSPOT_BASE_URL = 'https://app.hubspot.com/contacts/484866';
export const PANDADOC_CLIENT_ID = '439e935dfb976e339628';
export const PANDADOC_SECRET = 'de54b39bca4c2732497cb6ae512dadc19cf209c3';
export const PANDADOC_REDIRECT_URL = 'https://admin.boxcast.com/pandadoc';
export const INTERCOM_BASE_URL = 'https://app.intercom.com/a/apps/n4ioj8zx';



// WEBPACK FOOTER //
// ./environments/prod.js